import React from 'react';
import {LawLoadingDialog} from './LawLoadingDialog';
import {LawCard} from './LawCard';
import {LawAgentsProvider} from "../context/LawAgentsContext";
import {LawTransactionsProvider} from "../context/LawTransactionsContext";

export function LawPage() {
  return (
    <LawAgentsProvider>
      <LawTransactionsProvider>
        <LawLoadingDialog/>
        <LawCard/>
      </LawTransactionsProvider>
    </LawAgentsProvider>
  );
}
